import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["content", "icon", "label"]

  connect() {
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)
    this.handleDropdownOpen = this.handleDropdownOpen.bind(this)
    this.contentTarget.addEventListener("transitionend", this.handleTransitionEnd)
    document.addEventListener("dropdown:open", this.handleDropdownOpen)
    this.close(false)
  }

  disconnect() {
    this.contentTarget.removeEventListener("transitionend", this.handleTransitionEnd)
    document.removeEventListener("dropdown:open", this.handleDropdownOpen)
  }

  toggle(event) {
    event?.type === "keydown" && event.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open(animate = true) {
    this.isOpen = true
    document.dispatchEvent(new CustomEvent("dropdown:open", { detail: { source: this } }))
    this.contentTarget.hidden = false
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true")
    this.contentTarget.style.maxHeight = `${this.contentTarget.scrollHeight}px`

    if (!animate) {
      this.contentTarget.style.transitionDuration = "0ms"
      requestAnimationFrame(() => {
        this.contentTarget.style.transitionDuration = ""
      })
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }

    if (this.hasLabelTarget) {
      this.labelTargets.forEach((label) => { label.textContent = "Close" })
    }
  }

  close(animate = true) {
    this.isOpen = false
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false")
    this.contentTarget.style.maxHeight = "0px"

    if (!animate) {
      this.contentTarget.hidden = true
      this.contentTarget.style.transitionDuration = "0ms"
      requestAnimationFrame(() => {
        this.contentTarget.style.transitionDuration = ""
      })
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }

    if (this.hasLabelTarget) {
      this.labelTargets.forEach((label) => { label.textContent = "Expand" })
    }
  }

  handleTransitionEnd(event) {
    if (event.target !== this.contentTarget || event.propertyName !== "max-height") return

    if (!this.isOpen) {
      this.contentTarget.hidden = true
    }
  }

  handleDropdownOpen(event) {
    if (event.detail.source === this || !this.isOpen) return

    this.close()
  }
}
